<template>
  <div class="tags-view" v-if="views.length">
    <div
      v-for="item in views"
      :key="item.path"
      :class="['tag-item', { active: item.path === $route.path }]"
      @click="goTag(item)"
    >
      <span>{{ item.title }}</span>
      <i
        v-if="!item.affix"
        class="el-icon-close close-icon"
        @click.stop="closeTag(item)"
      ></i>
    </div>
  </div>
</template>

<script>
import { routes } from '../../router'
import { getDefaultAccessiblePath } from '../../utils/permissionRoute'

export default {
  name: 'TagsView',
  computed: {
    views() {
      return this.$store.getters.visitedViews
    }
  },
  methods: {
    goTag(item) {
      if (item.path !== this.$route.path) {
        this.$router.push(item.path)
      }
    },
    async closeTag(item) {
      await this.$store.dispatch('removeVisitedView', item.path)
      if (item.path === this.$route.path) {
        const views = this.$store.getters.visitedViews
        const last = views[views.length - 1]
        const defaultPath = getDefaultAccessiblePath(routes, this.$store.getters.permissionCodes)
        this.$router.push(last ? last.path : (defaultPath || '/'))
      }
    }
  }
}
</script>

<style scoped>
.tags-view {
  height: 40px;
  padding: 0 16px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  gap: 10px;
  overflow-x: auto;
}

.tag-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 12px;
  color: #606266;
  background: #fff;
  cursor: pointer;
  white-space: nowrap;
}

.tag-item.active {
  color: #fff;
  background: var(--theme-color);
  border-color: var(--theme-color);
}

.close-icon {
  font-size: 12px;
}
</style>
